<template>
    <div>
        <SelectionRequiredDialog /> 
        <DeletionDialog :context="'Selected' + context" />	
        <ErrorDialog />
    <ConfirmationDialog />
    <AzGroupsAssignTemplatesDialog />
        <ImageUploadDialog headline="lang_GENERAL_CAPTION_UPLOAD_IMAGE" />
        <ManageTagsDialog 
			context="AzGroups" 
			dir='az/groups'
			idAttributeName='alvIds'
		/>
        <BaseListPage
            headline="lang_AZ_GROUPS"
            :context="context"
            :alvqa="alvqa"
        >
        <template v-slot:filter>
            <v-col cols="3">
                <DropdownFilter 
                    :context="context + 'VisibilityFilter'"
                    label="lang_AZ_PERSONS_CAPTION_VISIBILITY"
                    :items="visibilityFilterItems"
                    :multiple="true"
                    :clearable="false"
                    :alvqa="alvqa + '-list-dropdown-visibility'"
                />
            </v-col>
        </template>
        <!-- DATA TABLE COMPONENT -->
            <template v-slot:dataTable>
                <BaseDataTableList
                    :headers="headers"
                    :context="context"
                    readOnlyGhostTdSpan="1"
                    :alvqa="alvqa"
                >
                <!-- TOPSLOT: actions, imports etc. -->
                    <template v-slot:topSlot><AzGroupsTopSlot /></template>
                <!-- DATA TABLE CONTENT: columns -->
                    <template v-slot:body="{ item }">
                        <ExpandIcon 
							:isExpanded="item.isExpanded" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
						/>
                        
                        <td>
                            <v-img
                                :src="
                                item.item.picture !== undefined && item.item.picture !== null
                                    ? item.item.picture
                                    : require('@/assets/default_picture/default.jpg')
                                "
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-image'"
                                width="40px"
                            ></v-img>
                        </td>
                        <td class="no_ellipsis">
                            <BaseTooltip 
                                :simpleText="item.item.group"
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-group'"
                            />
						</td>
						<td 
                            class="no_ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-key-name'"
                        >
							{{ item.item.gemaName }}
						</td>
						<td 
                            class="no_ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-city'"
                        >
							{{ item.item.city }}
						</td>
                        <td 
                            class="no_ellipsis"
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-alv-id'"
                        >
                            {{ item.item.alvId }}
                        </td>
                        <td class="no_ellipsis">
                            <BaseIcon   
                                :alvqa="alvqa + '-list-row-' + item.item.id + '-icon-upload-picture'"
                                icon="photo" 
                                :tooltipText="item.item.picture ? 'lang_GENERIC_CAPTION_CHANGE_IMAGE':'lang_GENERIC_CAPTION_UPLOAD_IMAGE'"
                                :color="item.item.picture ? 'buttonStandard' : 'standardBrownIcon'"
                                @click.stop="showImageUploadDialog(item.item)"
                            /> 
                        </td>
                    </template>
                    <template v-slot:expandSlot="{ id }"><AzGroupsReadOnly :itemId='id' /></template> 

                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
import BaseListPage from '@/components/_base/BaseListPage'
import BaseDataTableList from '@/components/_base/BaseDataTableList'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseIcon from '@/components/_buttons/BaseIcon'
import AzGroupsAssignTemplatesDialog from './_dialogs/AzGroupsAssignTemplatesDialog.vue'
import ConfirmationDialog from '@/components/_dialogs/ConfirmationDialog.vue'

import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import ErrorDialog from '@/components/_dialogs/ErrorDialog'
import ManageTagsDialog from '@/components/_dialogs/ManageTagsDialog'

import AzGroupsTopSlot from './AzGroupsTopSlot'
import AzGroupsReadOnly from "./_readonly/AzGroupsReadOnly"
import ImageUploadDialog from '@/components/_dialogs/ImageUploadDialog.vue'
import DropdownFilter from '@/components/_filters/DropdownFilter'

export default {
    name: "AzGroupsList",
    components: {
        BaseListPage,
        BaseDataTableList,
        ExpandIcon,
        BaseTooltip,
        SelectionRequiredDialog,
        DeletionDialog,
        ErrorDialog,
        ManageTagsDialog,
        AzGroupsTopSlot,
        AzGroupsReadOnly,
        ImageUploadDialog,
        BaseIcon,
        AzGroupsAssignTemplatesDialog,
        ConfirmationDialog,
        DropdownFilter
    },
    data() {
        return {
            context: "AzGroups",
            alvqa: "az-groups",
            publishingStatementsMappings: []
        }
    },
    computed: {
        getShowAzGroupsAssignTemplatesDialog() { return this.$store.getters.getShowAzGroupsAssignTemplatesDialog },
        visibilityFilterItems() {
            return [
                { text: this.$t('lang_GENERIC_VISIBLE'), value: 'visible', alvqa: this.alvqa + '-list-dropdown-visibility-visible' },
                { text: this.$t('lang_GENERIC_HIDDEN'), value: 'hidden', alvqa: this.alvqa + '-list-dropdown-visibility-hidden' },
                { text: this.$t('lang_GENERIC_CAPTION_MOBILE_APP'), value: 'mobile', alvqa: this.alvqa + '-list-dropdown-visibility-mobile' }
            ]
        },
        headers() {
            return [
                {
					text: '', 
					value: 'data-table-select', 
					align: 'center',
					width: "60px",
                    sortable: false,
					class: 'text-no-wrap'
                },
                {
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
					width: "48px",
                    sortable: false,
					class: 'text-no-wrap'
                },
                {
                    text: '', 
                    value: 'picture', 
                    align: 'center',
                    width: "65px",
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_AZ_GROUPS_CAPTION_GROUP_NAME'), 
                    value: 'group',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_AZ_CAPTION_GEMA_NAME'), 
                    value: 'gemaName',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERAL_CAPTION_CITY'), 
                    value: 'city',
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap'
                },
                {
					text: this.$t('lang_CAPTION_ALVID'),
					value: 'alvId', 
					align: 'left', 
					sortable: false,
					width: "170px",
					class: 'text-no-wrap'
				},
                {
					text: '', 
					value: 'editForm',
					align: 'right',
					sortable: false,
					width: "70px",
					class: 'text-no-wrap'
				},
                {
					text: '', 
					value: 'uploadPicture',
					align: 'right',
					sortable: false,
					width: "70px",
					class: 'text-no-wrap'
				}
            ]
        }
    },
    created() {
        this.$store.commit('setSelectedAzGroupsVisibilityFilter', ['visible', 'hidden'])
    },
    methods:{
        showImageUploadDialog(item){
            this.$store.commit('setImageUploaderContext',this.context)
            if(item.picture !== null){
                this.$store.commit('setImageUploaderImageExists',true)
            }
            this.$store.commit('set' + this.context + 'Details', item)
            this.$store.commit("setShowImageUploadDialog",true)
        }
    },
    watch: {}
}
</script>